import { render, staticRenderFns } from "./ClarifyAddModal.vue?vue&type=template&id=554b7236&"
import script from "./ClarifyAddModal.vue?vue&type=script&lang=ts&"
export * from "./ClarifyAddModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports